import { findOnixItemByValue } from "./selectMappers";
/**
 * Human readable description of an ONIX code, falling back to the raw code
 * when the codetable does not contain it.
 */
export var onixLabel = function (source, code) { var _a; return code ? ((_a = findOnixItemByValue(source, code)) === null || _a === void 0 ? void 0 : _a.description) || code : ""; };
